<template lang="pug">
  .pagination
    a.pagination__button(
    v-if="currentPage !== firstButton"
    href=""
    @click.prevent="onButtonClick(currentPage - 1)"
    )
      img(src="@/assets/images/icons/pagination-left-arrow.svg")

    a.pagination__button(
    href=""
    :class="{'pagination__button_active': currentPage === firstButton}"
    @click.prevent="onButtonClick(firstButton)"
    ) {{firstButton}}

    .pagination__button.pagination__button_empty(v-if="showStartEmptyButton") ...

    a.pagination__button(
    href=""
    v-for="button in intermediateButtons()"
    :class="{'pagination__button_active': currentPage === button}"
    @click.prevent="onButtonClick(button)"
    ) {{button}}

    .pagination__button.pagination__button_empty(v-if="showFinishEmptyButton") ...

    a.pagination__button(
    href=""
    :class="{'pagination__button_active': currentPage === lastButton}"
    @click.prevent="onButtonClick(lastButton)"
    ) {{lastButton}}

    a.pagination__button(
    v-if="currentPage !== lastButton"
    href=""
    @click.prevent="onButtonClick(currentPage + 1)"
    )
      img(src="@/assets/images/icons/pagination-right-arrow.svg")
</template>

<script>
export default {
  name: "custom-pagination",
  props: {
    elementsAmount: {
      type: Number,
    },
    amountToShow: {
      type: Number,
      default: 50,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      showStartEmptyButton: false,
      showFinishEmptyButton: false,
      showPrevButton: false,
      showNextButton: false,
    };
  },
  computed: {
    pagesAmount() {
      return Math.ceil(this.elementsAmount / this.amountToShow);
    },
    buttons() {
      let arr = [];
      for (let i = 0; i < this.pagesAmount; i++) {
        arr.push(i + 1);
      }
      return arr;
    },
    firstButton() {
      return this.buttons[0];
    },
    lastButton() {
      return this.buttons[this.buttons.length - 1];
    },
  },
  methods: {
    intermediateButtons() {
      let arr = this.buttons.slice(1, this.buttons.length - 1);
      if (arr.length <= 5) {
        return arr;
      }
      if (this.currentPage <= 4) {
        arr = arr.slice(0, 4);
        this.showStartEmptyButton = false;
        this.showFinishEmptyButton = true;
        return arr;
      }
      if (this.currentPage >= this.buttons.length - 3) {
        arr = arr.slice(arr.length - 4, arr.length + 1);
        this.showStartEmptyButton = true;
        this.showFinishEmptyButton = false;
        return arr;
      }
      arr = arr.slice(
        arr.indexOf(this.currentPage) - 1,
        arr.indexOf(this.currentPage) + 2
      );
      this.showStartEmptyButton = true;
      this.showFinishEmptyButton = true;
      return arr;
    },
    onButtonClick(button) {
      this.$emit("on-button-click", button);
    },
  },
};
</script>
